import React, { ReactNode } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

// Utils
import { useReferralParams } from './referral.helper';

// Types
export type ProductTypes = 'di';


type PartnerDataModel = {
    aff_id: string;
    source: string;
    name: string;
    phone: string | null;
    logo: string;
};

type CarrierDataModel = {
    id: number;
    name: string;
    products: Array<ProductTypes>;
};

type PartnerQueryModel = {
    json: {
        carriers: Array<CarrierDataModel>;
        partners: Array<PartnerDataModel>;
    }
};

type CoBrandingContextModel = {
    carrier: CarrierDataModel | null;
    partner: PartnerDataModel | null;
    // setPartner: React.Dispatch<React.SetStateAction<PartnerDataModel | null>>;
    // updatePartnerData: (prop: keyof PartnerDataModel, value: any) => void;
};

const CoBrandingContext = React.createContext({} as CoBrandingContextModel)


export const CoBrandingContextWrapper = ({ children }: { children: ReactNode | ReactNode[] }) => {
    const { json } = useStaticQuery<PartnerQueryModel>(CarriersAndPartnersQuery);
    // const [product, setProduct] = React.useState<ProductTypes | null>(null);

    const [cbid, setCbid] = React.useState<string | null>(null);
    const [source, setSource] = React.useState<string | null>(null);
    const [affId, setAffId] = React.useState<string | null>(null);


    // Cookies
    const referral = useReferralParams();    


    const carrier = React.useMemo<CarrierDataModel | null>(() => {        
        if ( cbid ) {
            return json?.carriers?.find(c => c.id === parseInt(cbid)) || null;
        }
        return null;
    }, [cbid]);


    const partner = React.useMemo<PartnerDataModel | null>(() => {
        const foundBySource = json?.partners?.find(p => p.source === source) || null;
        const foundByAffId = json?.partners?.find(p => p.aff_id === affId) || null;

        return foundByAffId || foundBySource || null;
    }, [source, affId]);
    


    // On marketing "cbid" change
    React.useEffect(() => {
        const coBrandingId = referral?.marketingCoBrandingId;

        if ( typeof window !== 'undefined' && coBrandingId && coBrandingId !== cbid ) {
            setCbid(coBrandingId);
        }
    }, [referral?.marketingCoBrandingId]);



    // On marketing "source" change
    React.useEffect(() => {
        const tuneSource = referral?.tuneSource;

        if ( typeof window !== 'undefined' && tuneSource && tuneSource !== source ) {
            setSource(tuneSource);
        }
    }, [referral?.tuneSource]);

    // On marketing "source" change
    React.useEffect(() => {
        const tunePartnerId = referral?.tunePartnerId;

        if ( typeof window !== 'undefined' && tunePartnerId && tunePartnerId !== source ) {
            setAffId(tunePartnerId);
        }
    }, [referral?.tunePartnerId]);

    return (
        <CoBrandingContext.Provider value={{
            carrier,
            partner
        }}>
            { children }
        </CoBrandingContext.Provider>
    )
};

export const useCoBranding = () => React.useContext(CoBrandingContext);

export const useCarrierByProduct = (product: ProductTypes | null) => {
    const context = React.useContext(CoBrandingContext);

    return {
        ...(product ? (() => {            
            if ( context.carrier?.products.includes(product) ) {
                return { carrier: context.carrier }
            }
            return null;
        })() : {})
    }
};



const CarriersAndPartnersQuery = graphql`
    query PartnersQuery {
        json: partnersJson {
            carriers {
                id
                name
                products
            }
            partners {
                aff_id
                source
                name
                phone
                logo
            }
        }
    }
`;